import { Component,Input, Output, EventEmitter, OnInit } from "@angular/core";
import { DynamicPanel, LandingPanel, GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { SessionComponent } from '../../component';
import { FormData } from 'src/app/framework-modules/formdata/form/formData';
import { DepartmentForm, DepartmentVo } from 'src/app/framework-modules/formdata/gen/departmentForm';
import { MessageService } from 'src/app/services/messageService';
import { CtDialogComponent } from 'src/app/framework-modules/elements/ct-dialog/component';
import { MatDialog } from '@angular/material';


@Component({
  selector: "department-add",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})
export class DepartmentAddComponent implements DynamicPanel,OnInit{
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session:SessionComponent;
  
  public form:DepartmentForm;
  public fd:FormData;
  public vo:DepartmentVo;
  
  constructor(private sa:ServiceAgent, private ms: MessageService, private dialog: MatDialog){
    this.form = DepartmentForm.getInstance();
    this.fd = new FormData(this.form,this.sa);

  }

  ngOnInit(){
  }

  save(){
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Save Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to save changes?';
    dialogRef.componentInstance.primary = 'Save';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.doAddDepartment();
    });
  }
  
  doCancel() {
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Discard Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to discard changes?';
    dialogRef.componentInstance.primary = 'Discard';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.parentPanel.navigate("DepartmentList", this.inputData);
    }); 
  }

  /**
   * Adds a new Department to the client's trust
   */
  doAddDepartment() {
    this.fd.saveAsNew().subscribe({
      next: vo => {
        this.ms.showSuccess("Department added successfully!")
      this.parentPanel.navigate("DepartmentList", this.inputData);
      },
      error: err => {
        this.ms.showError(err);
      }
    });
  }

  cancel(){
    this.parentPanel.navigate("DepartmentList", this.inputData);
  }

}